"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledLabelContainer = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _rebrand = require("../../icons-react/rebrand");
var StyledArrow = (0, _styledComponents["default"])(_rebrand.ChevronDown).withConfig({
  displayName: "SearcherDropdownLabel__StyledArrow",
  componentId: "sc-1od0x6b-0"
})(["height:13px;path{fill:var(--grey2);}", ""], function (_ref) {
  var opposite = _ref.opposite;
  return opposite && "\n      transform: rotate(180deg);\n    ";
});
var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDropdownLabel__StyledText",
  componentId: "sc-1od0x6b-1"
})(["width:100%;overflow:hidden;"]);
var StyledLabelContainer = exports.StyledLabelContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDropdownLabel__StyledLabelContainer",
  componentId: "sc-1od0x6b-2"
})(["box-shadow:", ";background:", ";height:45px;padding:0 8px;display:flex;align-items:center;cursor:default;user-select:none;font-size:16px;&:hover{cursor:pointer;}"], function (_ref2) {
  var theme = _ref2.theme;
  return "inset 0 0 0 1px  ".concat(theme.colors.moonMist);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
});
var SearcherDropdownLabel = exports["default"] = function SearcherDropdownLabel(_ref4) {
  var focused = _ref4.focused,
    isOpen = _ref4.isOpen,
    children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement(StyledLabelContainer, {
    focused: focused,
    open: isOpen
  }, /*#__PURE__*/_react["default"].createElement(StyledText, null, children), /*#__PURE__*/_react["default"].createElement(StyledArrow, {
    opposite: !!isOpen
  }));
};
SearcherDropdownLabel.defaultProps = {
  children: 'Открыть'
};
SearcherDropdownLabel.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  isOpen: _propTypes["default"].bool.isRequired,
  focused: _propTypes["default"].bool.isRequired
};